import ReactGA from "react-ga4";

import { ANALYTICS_CONSENT_EVENT } from "@/libraries/consent/events";

const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID as
  | string
  | undefined;
const isProduction = import.meta.env.VITE_ENV === "production";

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

let initialized = false;
let consentGranted = false;
let pendingUserId: string | null = null;

const gtag = (...args: unknown[]): void => {
  if (window.gtag) {
    window.gtag(...args);
  }
};

if (measurementId && isProduction) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push([
    "consent",
    "default",
    {
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      analytics_storage: "denied",
    },
  ]);

  ReactGA.initialize(measurementId, {
    gtagOptions: { send_page_view: false },
  });
  initialized = true;

  window.addEventListener(ANALYTICS_CONSENT_EVENT, (event) => {
    consentGranted = (event as CustomEvent<boolean>).detail;
    gtag("consent", "update", {
      analytics_storage: consentGranted ? "granted" : "denied",
    });
    if (consentGranted && pendingUserId) {
      ReactGA.set({ user_id: pendingUserId });
    } else if (!consentGranted) {
      ReactGA.set({ user_id: null });
    }
  });
}

export const trackPageview = (path: string): void => {
  if (!initialized) return;
  ReactGA.send({ hitType: "pageview", page: path });
};

export const setAnalyticsUser = (userId: string | number): void => {
  if (!initialized) return;
  pendingUserId = String(userId);
  if (consentGranted) {
    ReactGA.set({ user_id: pendingUserId });
  }
};

export const clearAnalyticsUser = (): void => {
  if (!initialized) return;
  pendingUserId = null;
  ReactGA.set({ user_id: null });
};

export { default as AnalyticsTracker } from "./AnalyticsTracker";
